import { Component, OnInit } from '@angular/core';
import { GiftBagService } from 'src/app/shared/components/gift-bag/gift-bag.service';
import { Item } from '../../../core/models/item.model';
import { Subscription } from 'rxjs';
import { ModalService } from 'src/app/shared/components/modal/modal.service';
import { EndListModalComponent } from '../end-list-modal/end-list-modal.component';

@Component({
  selector: 'app-gift-bag-modal',
  templateUrl: './gift-bag-modal.component.html',
  styleUrls: ['./gift-bag-modal.component.scss']
})
export class GiftBagModalComponent implements OnInit {

  public itemsBag: Item[] = [];
  private subscription$: Subscription;

  constructor(
    private modal: ModalService,
    private giftBagService: GiftBagService
  ) { }

  ngOnInit(): void {
    this.itemsBag = this.giftBagService.getItemsBag();
    this.subscription$ = this.giftBagService.changeItems$.subscribe((items) => {
      if (items.length == 0) {
        this.onClose();
      } else {
        this.itemsBag = this.giftBagService.getItemsBag();
      }
    });
  }

  onClose() {
    this.modal.closeModal();
    this.subscription$.unsubscribe();
  }

  public endList(): void {
    this.onClose();
    this.modal.showModal(EndListModalComponent);
  }
}
